<template>
  <div class="Ordercontent">
    <van-tabs v-model="active" @click="changeTab">
      <van-tab title="全部">
        <van-swipe-cell :right-width="80" :left-width="0" :disabled="item.status!=0" :on-close="onClose" v-for="(item,i) in OrderList" :key="i" v-if="OrderList" >
          <a href="javascript:;" class="billBar" @click.stop="gotoOrderPay(item)">
            <van-row >
              <van-col span="24" class="title"><i class="icon"></i>{{item.create_time}}</van-col>
              <van-col span="24" class="cont">
                <van-col span="24" class="address">{{item.city+item.area+item.address}}</van-col>
                <van-col span="18" class="money" v-if="item.status==0">待缴金额：<span class="orange">¥ {{item.money}}</span></van-col>
                <van-col span="18" class="money" v-if="item.status==1">本季已缴热费：¥ {{item.money}}</van-col>
                <van-col span="6" class="payBtn">
                  <van-button round type="danger" class="solidBtn" v-if="item.status==0" @click.stop="goPayment(item.roomId)">去缴费</van-button>
                  <van-button round type="danger" class="hollowBtn" v-if="item.status!=0" @click.stop="gotoPath('/reportrepair',item)">去报修</van-button>
                </van-col>
              </van-col >
            </van-row>
          </a>
          <van-button
            square
            slot="right"
            type="danger"
            text="删除"
          />
        </van-swipe-cell>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
      <van-tab title="未缴费">
        <van-swipe-cell :right-width="80" :left-width="0" :disabled="item.status!=0" :on-close="onClose" v-for="(item,i) in OrderList" :key="i" v-if="OrderList" >
          <a href="javascript:;" class="billBar" @click.stop="gotoOrderPay(item)">
          <van-row >
            <van-col span="24" class="title"><i class="icon"></i>{{item.create_time}}</van-col>
            <van-col span="24" class="cont">
              <van-col span="24" class="address">{{item.city+item.area+item.address}}</van-col>
              <van-col span="18" class="money" v-if="item.status==0">待缴金额：<span class="orange">¥ {{item.money}}</span></van-col>
              <van-col span="18" class="money" v-if="item.status==1">本季已缴热费：¥ {{item.money}}</van-col>
              <van-col span="6" class="payBtn">
                <van-button round type="danger" class="solidBtn" v-if="item.status==0" @click.stop="goPayment(item.roomId)">去缴费</van-button>
                <!--<van-button round type="danger" class="hollowBtn" >去报修</van-button>-->
              </van-col>
            </van-col >
          </van-row>
          </a>
          <van-button
            square
            slot="right"
            type="danger"
            text="删除"
          />
        </van-swipe-cell>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
      <van-tab title="已缴费">
        <a href="javascript:;" class="billBar" v-for="(item,i) in OrderList" :key="i"  @click.stop="gotoOrderPay(item)">
          <van-row >
            <van-col span="24" class="title"><i class="icon"></i>{{item.create_time}}<span v-show="item.status=='5'" style="margin-left:10px;padding: 2px 5px;background-color: #ff0000;color: #fff;">异常</span></van-col>
            <van-col span="24" class="cont">
              <van-col span="24" class="address">{{item.city+item.area+item.address}}</van-col>
              <van-col span="18" class="money" v-if="item.status==0">待缴金额：<span class="orange">¥ {{item.curMoney}}</span></van-col>
              <van-col span="18" class="money" v-if="item.status==1">本季已缴热费：¥ {{item.curMoney}}</van-col>
              <van-col span="6" class="payBtn">
                <van-button round type="danger" class="solidBtn" v-if="item.status==0" @click.stop="goPayment(item.roomId)">去缴费</van-button>
                <van-button round type="danger" class="hollowBtn" v-if="item.status!=0" @click.stop="gotoPath('/reportrepair',item)">去报修</van-button>
				<van-button round type="danger" class="hollowBtn" style="margin-top:10px" v-if="item.status!=0 && item.invoice_apply_status==0 && item.issueCount ==0 && isShowApply" @click.stop="gotoInvoicing(item)">申请开票</van-button>
              </van-col>
            </van-col >
          </van-row>
        </a>
        <van-row  class="noPayBar" v-if="OrderList.length == 0">
          <van-col span="24" class="noPayPC"></van-col>
          <van-col span="24" class="text1 orange">没有找到该用户！</van-col>
          <van-col span="24" class="text2">去试试【自主信息填写缴费】吧！</van-col>
        </van-row>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { Dialog } from 'vant';
  import { reqOrderList, reqOrderDelete,reqInvoiceList } from '../../api'
  import {bqCompanyId} from '../../common/js/env'
	export default {
    name:"order",
	  data(){
	    return{
        active:0,
        orderData:{
          userId:'',
          status:'0,1,5'//0,1全部  0待  1已 5异常
        },
        OrderList:'',
		isShowApply:false,//是否显示申请发票
      }
    },
    created(){
      this.orderData.userId = this.$cookies.get('userInfo').userId
	  if(this.$cookies.get('companyId') == bqCompanyId){
		  this.isShowApply = true
	  }
	  this.init()
    },
    mounted(){
      this.getOrderList();
    },
    methods:{
		init(){
			//申请过发票的 不能再申请
			// reqInvoiceList(this.orderData).then(res => {
			// 	if (res.status == '200') {
			// 		var re = JSON.parse(res.data).data.list
			// 		if(re.length>0){
			// 			this.isShowApply = false
			// 		}
			// 	}
			// })
		},
      //跳转地址选择
      gotoPath(path,item){
        let repairAddress = {
          address:item.city+item.area+item.address,
          roomId:item.roomId
        }
        this.$cookies.remove('repairAddress');
        this.$cookies.set('repairAddress',repairAddress);
        this.$router.push({
          path:path,
          name:path.substring(1),
          query:{source:'order'}//标明当前文件
        })
      },
	  gotoInvoicing(item){
		  this.$router.push({
		    path:'/invoicing',
		    name:'invoicing',
		    query:item//标明当前文件
		  })
	  },
	    /*
	    * 获取订单列表
	    * */
      getOrderList(){
        //获取对应小区
        reqOrderList(this.orderData).then(res => {
          if(res.success){
            this.OrderList = res.data
          }else {
            Toast.fail({message:res.msg,className:'apiLoading'});
          }
        })
      },
      /*
      * 点击切换tab，通过active的不同来获取对应数据
      * */
      changeTab(){
        if(this.active==0){
          //全部
          this.orderData.status = '0,1,5'
        }else if(this.active==1){
          //待缴费
          this.orderData.status = '0'
        }else if(this.active==2){
          //已缴费
          this.orderData.status = '1,5'
        }
        this.getOrderList()
      },
      goPayment(roomId){
        this.$router.push({
          path:'/paydetail',
          name:'paydetail',
          query:{roomId:roomId,isPay:true}
        });
      },
      /*
      * 查看订单详情
      * */
      gotoOrderPay(data){
        let orderInfo = {
          order_no:data.order_no,
          orderId:data.ID,
          city:data.city,
          area:data.area,
          address:data.address,
          userCardNumber:data.userCardNumber,
          useArea:data.useArea,
          money:data.money,
          userName:data.userName,
          status:data.status,
          roomId:data.roomId
        }
        this.$cookies.remove('orderInfo');
        this.$cookies.set('orderInfo',orderInfo);
        this.$router.push({
          path:'/orderdetail',
          name:'orderdetail'
        });
      },
      /*
      * 滑块删除
      * */
      onClose(clickPosition, instance) {
        switch (clickPosition) {
          case 'left':
          case 'cell':
          case 'outside':
            instance.close();
            break;
          case 'right':
            Dialog.confirm({
              message: '确定删除吗？',
              closeOnClickOverlay: true
            }).then(() => {
              console.log(instance);
              console.log(instance.$options._parentVnode.key);
              //删除订单
              if(instance.$options._parentVnode.key){
                let data= {
                  orderId:instance.$options._parentVnode.key
                }
                reqOrderDelete(data).then(res => {
                  if(res.success){
                    instance.close();
                    this.getOrderList();
                    Toast.success({message:'删除成功！',className:'apiLoading'});
                  }else {
                    Toast.fail({message:res.msg,className:'apiLoading'});
                  }
                })
              }else{
                Toast.fail({message:'删除失败',className:'apiLoading'});
              }
            }).catch(() => {
              // on cancel
            });
            break;
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .orange
    color #ff6d02
  .Ordercontent
    padding-bottom 80px
    background #f9f9f9
    .van-tabs--line
      .van-tabs__wrap
        height 90px
      .van-tab
        font-size 30px
        line-height 80px
      .van-tab--active
        color #ff6d02
      .van-tabs__content
        padding-top 60px
        .billBar
          display inline-flex
          border-top 20px solid #f9f9f9
          .van-row
            padding 0px 54px 40px 50px
            background #fff
          .title
            font-size 26px
            color #999999
            padding 42px 0px 36px
            border-bottom 2px solid #f0f0f0
            .icon
              display inline-flex
              width 22px
              height 22px
              margin-right 12px
              background url("./images/time_icon.png") no-repeat center
              background-size 100% 100%
          .cont
            font-size 28px
            color #888888
            .bill-money
              padding 34px 0px
          .address
            font-size 30px
            color #222222
            line-height 40px
            padding 30px 0px
          .money
            font-size 28px
            color #888888
            span
              font-size 60px
    .noPayBar
      margin 10px 0px
      height 626px
      background #ffffff
      text-align center
      .noPayPC
        height 50%
        margin-top 15%
        background url("./images/unfound_5.png") no-repeat center
        background-size 50% auto
      .text1
        font-size 32px
        padding 20px 0px
      .text2
        font-size 24px
        color #aaaaaa
    .van-swipe-cell__right
      padding-top 20px
      .van-button
        width 165px
        height 100%
        font-size 28px
        text-align center
        letter-spacing 6px
    .solidBtn
      width 166px
      height 66px
      font-size 28px
      background #ff6d02
    .hollowBtn
      width 166px
      height 66px
      background transparent!important
      color #ff6d02
      font-size 28px
      border 2px solid #ff6d02
</style>



// WEBPACK FOOTER //
// src/pages/Order/Order.vue